export enum ActionType{
    LOCK_COMMAND = 'LOCK_COMMAND',
    UNLOCK_COMMAND = 'UNLOCK_COMMAND',
    OPEN_LATCHES_COMMAND = 'OPEN_LATCHES_COMMAND',
    ODOMETER_COMMAND = 'ODOMETER_COMMAND',
    CUSTOM_COMMAND = 'CUSTOM_COMMAND',
    FIND = 'FIND',
    NOTES = 'NOTES',
    RESET = 'RESET',
    UNKNOWN = 'UNKNOWN'
}